export default __webpack_public_path__ + "4ce302527f0410e5fc361c77c458bcd4.png";